// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heartbeat-dialog {
  z-index: 1000000!important;
}
.heartbeat-dialog .k-dialog {
  width: 480px;
  padding: 0;
  border-radius: 16px;
  overflow: hidden;
}

.heartbeat-card {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
}

.view-preference-option:has(input:checked) {
  border-color: #865bdf;
  background: #fbf9ff;
}

.heartbeat-image img {
    width: -webkit-fill-available;
}

.heartbeat-content {
  padding: 30px;
  text-align: center;
}

.heartbeat-content h2 {
  margin: 0 0 12px 0;
  font-size: 18px;
  color: #000;
  font-weight: 600;
}

.heartbeat-content p {
  font-size: 12px;
  color: #666;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  margin: 0;
  text-align: left;
}

.heartbeat-content p img {
  vertical-align: middle;
}

.learn-more {
  color: #865BDF;
  cursor: pointer;
}

.learn-more:hover {
  text-decoration: underline;
}

.heartbeat-footer {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: end;
      -ms-flex-pack: end;
          justify-content: flex-end;
  padding: 15px 30px;
  border-top: 1px solid #dadada;
}

.heartbeat-button {
    border-radius: 100px;
    border: 1px solid #525252;
    background: #525252;
    color: white;
    padding: 5px 12px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
}

.heartbeat-button:hover {
  background-color: #333333;
}


/* 📱 Mobile 端适配 */
  .mobile-heartbeat-dialog .k-dialog {
    width: 90% !important; /* 几乎全屏 */
  }

  .mobile-heartbeat-dialog  .heartbeat-content {
    text-align: left;
  }

  .mobile-heartbeat-dialog  .heartbeat-footer {
    padding: 16px 20px;
  }

  .mobile-heartbeat-dialog .heartbeat-button {
    padding: 14px 40px;
    color: #FFF;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px; /* 125% */
  }
`, "",{"version":3,"sources":["webpack://./src/css/HeartBeatDialog.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,qBAAyB;MAAzB,kBAAyB;UAAzB,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,kBAAkB;EAChB;IACE,qBAAqB,EAAE,SAAS;EAClC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;EAC9B","sourcesContent":[".heartbeat-dialog {\n  z-index: 1000000!important;\n}\n.heartbeat-dialog .k-dialog {\n  width: 480px;\n  padding: 0;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n.heartbeat-card {\n  display: flex;\n  flex-direction: column;\n}\n\n.view-preference-option:has(input:checked) {\n  border-color: #865bdf;\n  background: #fbf9ff;\n}\n\n.heartbeat-image img {\n    width: -webkit-fill-available;\n}\n\n.heartbeat-content {\n  padding: 30px;\n  text-align: center;\n}\n\n.heartbeat-content h2 {\n  margin: 0 0 12px 0;\n  font-size: 18px;\n  color: #000;\n  font-weight: 600;\n}\n\n.heartbeat-content p {\n  font-size: 12px;\n  color: #666;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  margin: 0;\n  text-align: left;\n}\n\n.heartbeat-content p img {\n  vertical-align: middle;\n}\n\n.learn-more {\n  color: #865BDF;\n  cursor: pointer;\n}\n\n.learn-more:hover {\n  text-decoration: underline;\n}\n\n.heartbeat-footer {\n  display: flex;\n  justify-content: flex-end;\n  padding: 15px 30px;\n  border-top: 1px solid #dadada;\n}\n\n.heartbeat-button {\n    border-radius: 100px;\n    border: 1px solid #525252;\n    background: #525252;\n    color: white;\n    padding: 5px 12px;\n    font-size: 14px;\n    font-weight: 400;\n    cursor: pointer;\n}\n\n.heartbeat-button:hover {\n  background-color: #333333;\n}\n\n\n/* 📱 Mobile 端适配 */\n  .mobile-heartbeat-dialog .k-dialog {\n    width: 90% !important; /* 几乎全屏 */\n  }\n\n  .mobile-heartbeat-dialog  .heartbeat-content {\n    text-align: left;\n  }\n\n  .mobile-heartbeat-dialog  .heartbeat-footer {\n    padding: 16px 20px;\n  }\n\n  .mobile-heartbeat-dialog .heartbeat-button {\n    padding: 14px 40px;\n    color: #FFF;\n    text-align: center;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 20px; /* 125% */\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
